<template>
<section>
  <b-card class="cissetting mb-1 sticky-top" id="userList-card">
    <b-row>
      <b-col>
        <div id="adminMenu" style="margin-left: 0rem;">
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="account"
            size=""
            button
            @change="adminMenuClick('account')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            ACCOUNT
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="prices"
            size=""
            button
            @change="adminMenuClick('prices')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            PRICES
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-model="selectedAdminMenu"
            value="users"
            size=""
            button
            @change="adminMenuClick('users')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            USERS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="seeds"
            size=""
            button
            @change="adminMenuClick('seeds')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SEEDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="keywords"
            size=""
            button
            @change="adminMenuClick('keywords')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            KEYWORDS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="synonyms"
            size=""
            button
            @change="adminMenuClick('synonyms')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            SYNONYMS
          </b-form-radio>
          <b-form-radio
            class="btn-radio"
            v-if="hasSuperAdminRole()"
            v-model="selectedAdminMenu"
            value="uncategorized"
            size=""
            button
            @change="adminMenuClick('uncategorized')"
            style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
          >
            UNCATEGORIZED
          </b-form-radio>
        </div>
      </b-col>
    </b-row>
  </b-card>

  <b-card class="mb-1" style="font-family: NanumBarunGothic;">
    <b-row class="mt-1">
      <b-col cols="2" style="display:table;">
        <span style="display:table-cell; vertical-align:middle; font-weight: bold; font-size: x-large; color: #595858;">ACCOUNT INFO</span>
      </b-col>
      <b-col cols="2">
        <vue-select
          v-if="hasSuperAdminRole()"
          label="title"            
          :options="accountList"
          :clearable="false"
          :multiple="false"
          v-model="selectedAccount"
          class="account-select"
          placeholder="Select Account"
        >
        </vue-select>
      </b-col>
      <b-col cols="8">
        <b-button
          v-if="hasSuperAdminRole()"
          class="mr-40 my-40 float-right"
          variant="danger"
          style="margin-left: 1rem;"
          @click="delAccount"
        >
          DEL
        </b-button>
        <b-button
          class="mr-40 my-40 float-right"
          variant="secondary"
          v-b-modal.update-account-modal
          style="margin-left: 1rem;"
        >
          EDIT
        </b-button>
        <b-button
          v-if="hasSuperAdminRole()"
          class="mr-40 my-40 float-right"
          variant="primary"
          v-b-modal.add-account-modal
        >
          ADD
        </b-button>
      </b-col>
    </b-row>
  </b-card>



  
  <b-card class="m-0" style="font-family: NanumBarunGothic;">

    <!-- <b-row class="float-right">
      <feather-icon
        v-if="hasUpdatePermission('ad-accounts')"
        class="mr-1 cursor-pointer"
        icon="Edit2Icon"
        size="16"
        v-b-modal.update-ad-account-modal
        fill
      />
    </b-row> -->

    <hr style="margin-top: 2rem; margin-bottom: 2rem; height: 2px;  background-color : lightgray; border: 0;">

    <b-row class="mt-3">
      <b-col cols="4">
        <h5><b>Title</b></h5>
      </b-col>
      <b-col cols="8">{{ account.title }}</b-col>
    </b-row>
    <!-- <b-row class="mt-1">
      <b-col cols="4">
        <h5>ID</h5>
      </b-col>
      <b-col cols="8">{{ account.id }}</b-col>
    </b-row> -->
    <b-row class="mt-1">
      <b-col cols="4">
        <h5><b>Description</b></h5>
      </b-col>
      <b-col cols="8">{{ account.description }}</b-col>
    </b-row>

    <hr style="margin-top: 2rem; margin-bottom: 2rem; height: 2px;  background-color : lightgray; border: 0;">

    <b-row class="mt-3">
      <b-col cols="4">
        <h5><b>Price</b></h5>
      </b-col>
      <b-col cols="8">{{ account.priceNm }}</b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="4">
        <h5><b>Price Start Date</b></h5>
      </b-col>
      <b-col cols="8">
        {{
          formatDate(account.priceStartDt, {
            month: "short",
            day: "numeric",
            year: "numeric",
          })
        }}
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="4">
        <h5><b>Price End Date</b></h5>
      </b-col>
      <b-col cols="8">
        {{
          formatDate(account.priceEndDt, {
            month: "short",
            day: "numeric",
            year: "numeric",
          })
        }}
      </b-col>
    </b-row>

    <hr style="margin-top: 2rem; margin-bottom: 2rem; height: 2px;  background-color : lightgray; border: 0;">

    <b-row class="mt-3">
      <b-col cols="4">
        <h5><b>Auto Extension</b></h5>
      </b-col>
      <b-col cols="8">{{ account.autoExtension }}</b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="4">
        <h5><b>Extension Number</b></h5>
      </b-col>
      <b-col cols="8">{{ account.extensionNum }}</b-col>
    </b-row>

    <hr style="margin-top: 2rem; margin-bottom: 2rem; height: 2px;  background-color : lightgray; border: 0;">

    <b-row class="mt-3">
      <b-col cols="4">
        <h5><b>Basic Categories</b> ({{ account.nowCateNum }} / {{ account.maxCateNum }})</h5>
      </b-col>
      <b-col cols="8">
        <span v-for="item in account.categories" :key="item.id">
          <b-row>
            <b-col cols="2">
              <span>{{ item.title }}</span>
            </b-col>
            <b-col>
              <span>{{ account.priceStartDt }}</span> ~ <span>{{ account.priceEndDt }}</span>
            </b-col>
          </b-row>
        </span>
      </b-col>
    </b-row>
    
    <b-row class="mt-3">
      <b-col cols="4">
        <h5 v-if="account.extraCategories"><b>Extra Categories</b> ({{ account.extraCategories.length }})</h5>
        <!-- <h5><b>Extra Categories</b></h5> -->
      </b-col>
      <b-col cols="8">
        <span v-for="item in account.extraCategories" :key="item.ctgSq">
          <b-row>
            <b-col cols="2">
              <span>{{ item.ctgNm }}</span>
            </b-col>
            <b-col cols="3">
              <span>{{ item.relStartDt }}</span> ~ <span>{{ item.relEndDt }}</span>
            </b-col>
            <b-col>
              <span>&#8361; {{ item.relPrice }}0,000</span>
            </b-col>
          </b-row>
        </span>
      </b-col>
    </b-row>

    <hr style="margin-top: 2rem; margin-bottom: 2rem; height: 2px;  background-color : lightgray; border: 0;">

    <b-row class="mt-3">
      <b-col cols="4">
        <h5><b>Created At</b></h5>
      </b-col>
      <b-col cols="8">
        {{
          formatDate(account.createdAt, {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
          })
        }}
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="4">
        <h5><b>Last Updated At</b></h5>
      </b-col>
      <b-col cols="8">
        {{
          formatDate(account.updatedAt, {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
          })
        }}
      </b-col>
    </b-row>

    <hr style="margin-top: 2rem; margin-bottom: 2rem; height: 2px;  background-color : lightgray; border: 0;">

    

    <update-account-modal
      v-if="account.id"
      :refreshData="setAccounts"
      :account="account"
      :prevPrice="prevPrice"
    />

    <add-account-modal
      :refreshData="setAccounts"
      :account="account"
    />

  





      
    
    

    
  </b-card>
</section>
</template>

<script>
import {
  BCard,
  BCol,
  BRow,
  BCardBody,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BLink,
  BTooltip,
  BPagination,
  BFormRadio,
} from "bootstrap-vue";

// import cisUsersList from "@/views/cis-settings/components/cisUsersList";
// import InviteUserModal from "@/views/cis-settings/modal/InviteUserModal";
// import UpdateUserModal from "@/views/cis-settings/modal/UpdateUserModal";

import UpdateAccountModal from "@/views/cis-settings/modal/UpdateAccountModal";
import AddAccountModal from "@/views/cis-settings/modal/AddAccountModal";
import AdaccountService from "@/services/ad-account.service";
import { formatDate } from "@core/utils/filter";

import CISAccountService from "@/services/cis-account.service";


import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import vSelect from "vue-select";

import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "AdAccountUsers",
  components: {
    BCard,
    BCol,
    BRow,
    BCardBody,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BLink,
    BTooltip,
    BPagination,
    // InviteUserModal,
    // UpdateUserModal,
    UpdateAccountModal,
    AddAccountModal,
    vSelect,
    BFormRadio,
  },
  data() {
    return {
      account: {},
      accountList: [],
      selectedAccount: "",
      selectedAdminMenu: "account",
      prevPrice: 0,
    };
  },
  computed:{
    check_adminMenu() {
      return this.$store.getters.getSelectedAdminMenu
    }
  },
  watch: {
    check_adminMenu(value) {
      this.selectedAdminMenu = value
    },
    selectedAccount() {
      this.prevPrice = this.selectedAccount.priceId;
      this.account = this.selectedAccount;      
      console.log(this.account)
      this.$root.$emit("refresh-accountinfo", this.account);
    }
  },
  methods: {
    adminMenuClick(mode) {      
      this.$store.dispatch('callAdminMenu', { adminMenu: mode })

      switch(mode) {
        case 'account':
          this.$router.push({ name: "cis-account" }).catch(() => {});
          break;
        case 'prices':
          this.$router.push({ name: "cis-prices" }).catch(() => {});
          break;
        case 'users':
          this.$router.push({ name: "cis-users" }).catch(() => {});
          break;
        case 'seeds':
          this.$router.push({ name: "cis-seeds" }).catch(() => {});
          break;
        case 'keywords':
          this.$router.push({ name: "cis-keywords" }).catch(() => {});
          break;
        case 'synonyms':
          this.$router.push({ name: "cis-synonyms" }).catch(() => {});
          break;
        case 'uncategorized':
          this.$router.push({ name: "cis-uncategorized" }).catch(() => {});
          break;
      }
    },


    delAccount(){
      console.log('-- delAccount --')
      console.log(this.account)

      this.$swal({
        title: "Are you sure?",
        text: `You want to delete the account!`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await CISAccountService.delAccount(this.account);
          if (response && response.status === 200) {
            this.setAccounts();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully deleted!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });


    },


    async setAccounts() {

      console.log('-- setAccounts --')
      console.log(useJwt.getUserData())
      var adacctId = useJwt.getUserData().adacctId

      const accounts = await CISAccountService.accountList();
      if (accounts.data.success) {
        this.accountList = accounts.data.data;
        
        for(const item of accounts.data.data) {
          if(item.id == adacctId){
            this.selectedAccount = item
          }
        }
        // this.selectedAccount = this.accountList[0]
      }
    },

    async refreshAccounts(id) {
      console.log('-- refreshAccount --')
      const oneAccount = await CISAccountService.getAccount(id);
      if (oneAccount.data.success) {
        this.selectedAccount = oneAccount.data.data;
      }
    },


    openCreateAdAccountModal(id, mode) {
      this.createAdAccountModalKey = Math.floor(Math.random() * 100);
      this.editingId = id ? id : null;
      this.editingMode = mode ? mode : null;
      this.$nextTick(() => {
        this.$bvModal.show("create-ad-account-modal");
      });
    },



    
  },
  setup() {
    return {
      formatDate,
    };
  },
  created() {
    this.setAccounts();
  },
};
</script>

<style lang="scss">

.mb-1 .sticky-top{
  align-self: flex-start;
}

.cissetting .card-body {
    padding: 1.0rem;
  }

#adminMenu .btn-radio .btn-secondary {
  background-color: #4E86FF !important;
  border-color: #4E86FF !important;
  box-shadow: none;
}


#adminMenu .btn-radio .btn-secondary.active {
  background-color: #1951dc !important;
  border-color: #1c5cff !important;
  // box-shadow: 0 6px 30px -6px #002896;
  // font-weight: 600;
  // font-size: 1.3rem;
}


.account-select .vs__dropdown-menu {
  padding: 0px 0px 0px 0px;
}

</style>
